import { Fragment } from "react"
import { Outlet } from "react-router-dom"

const ExpenseTypesWrapper = () => {

    return (
        <Fragment>
           <Outlet/>
        </Fragment>
    )
}

export default ExpenseTypesWrapper 